import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuGroupProps extends PartProps<BaseContextMenu.Group.Props> {
  className?: string
}

function ContextMenuGroup({ className, children, ...props }: ContextMenuGroupProps) {
  return (
    <BaseContextMenu.Group className={twMerge(className)} {...props}>
      {children}
    </BaseContextMenu.Group>
  )
}

export { ContextMenuGroup }
